import React, { useEffect, useState } from "react";
import {
  activeDeactiveShopById,
  deleteOShopById,
  getShopById,
  getShopListSub,
  hardDeleteOShopById,
} from "../../services/shop.service";
import MaterialTable from "material-table";
import moment from "moment";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { Edit as EditIcon, Delete as DeleteIcon } from "@material-ui/icons";
import { toast } from "react-hot-toast";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import CustomModel from "../../components/CustomModel";
import PersonAddIcon from "@material-ui/icons/PersonAdd";
import { Badge, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import PersonOutlineOutlinedIcon from "@material-ui/icons/PersonOutlineOutlined";
import CallOutlinedIcon from "@material-ui/icons/CallOutlined";
import MailOutlineSharpIcon from "@material-ui/icons/MailOutlineSharp";
import StorefrontIcon from "@material-ui/icons/Storefront";
import Switch from "react-switch";

const styles = {
  header: {
    backgroundColor: "#007bff",
    color: "white",
    fontSize: "18px",
    marginTop: "0",
    marginBottom: "0",
    fontFamily: "Helvetica",
  },
  col: {
    paddingTop: "4px",
    margin: "5px",
    border: "1px solid #007bff",
  },
  coladjust: {
    display: "flex",
  },
  dropDown: {
    paddingLeft: "5px",
  },
  item: {
    border: "2px solid #007bff",
    paddingTop: "8px",
    width: "700px",
    height: "50px",
  },
  title: {
    marginLeft: "10px",
  },
};

const useStyles = makeStyles(styles);

function ShopListSub(props: any) {
  const classes = useStyles();
  const [shopListArray, setShopListArray] = useState([]);
  const [openModel, setOpenModel] = React.useState(false);
  const [shopUsername, setShopUsername] = useState("");
  const [hardDelete, setHardDelete] = useState(false);

  const [shopDataById, setShopDataById] = useState<{
    username: string;
    phone: string;
    email: string;
    number_of_shops: number;
  }>({
    username: "",
    phone: "",
    email: "",
    number_of_shops: 0,
  });

  useEffect(() => {
    if (localStorage.getItem("token") === "Admin") {
      const username = props?.match?.params?.username;
      localStorage.setItem("redirect", username);
      getList();
      getShopById(username)
        .then((res) => {
          setShopDataById(res?.data);
        })
        .catch((e) => {
          console.log(e);
          toast.error("Something went wrong.");
        });
    } else {
      props.history.push("/login");
    }
    localStorage.setItem("shop_id", "");
    localStorage.setItem("username", "");
  }, []);

  const getList = () => {
    getShopListSub(props?.match?.params?.username)
      .then((res: any) => {
        console.log("res?.data", res?.data);
        setShopListArray(res?.data);
      })
      .catch((err) => console.log(err));
  };

  const editShop = (username: string) => {
    const shopDetail = shopListArray.filter(
      (item: any) => item.username === username
    )[0];
    props.history.push({
      pathname: `/shop/edit/${username + "_" + shopDetail["franchise_name"]}`,
      details: shopDetail,
    });
  };
  const deleteShop = (id: string) => {
    setShopUsername(id);
    setOpenModel(true);
  };
  const harddeleteShop = (id: string) => {
    setShopUsername(id);
    setHardDelete(true);
    setOpenModel(true);
  };
  const handleChange = (username: string, available: boolean) => {
    activeDeactiveShopById(username, !available)
      .then((res: any) => {
        toast.success(res.message);
        getList();
      })
      .catch((err) => toast.error(err.message));
  };
  const [conform, setConform] = useState("");
  const [password, setPassword] = useState("");

  const onDeleteShop = () => {
    if (password == "") {
      toast.success("Enter Password");
      return;
    }
    if (password != "tArun@#123..&&mEhul@#123..") {
      toast.success("Enter Valid Password");
      return;
    }
    if (hardDelete) {
      hardDeleteOShopById(shopUsername)
        .then((res: any) => {
          toast.success(res.message);
          getList();
        })
        .catch((err) => toast.error(err.message));
    } else {
      deleteOShopById(shopUsername)
        .then((res: any) => {
          toast.success(res.message);
          getList();
        })
        .catch((err) => toast.error(err.message));
    }
    setOpenModel(false);
    setHardDelete(false);
  };

  const toggleCustomModel = () => {
    setOpenModel(!openModel);
    setHardDelete(false);
  };
  
  return (
    <>
      <CustomModel
        isModelOpen={openModel}
        toggleModel={toggleCustomModel}
        dialogTitle={"Remove Shop?"}
        dialogContentText={"This will deactivate your shop."}
        dialogBody={
          <div className="row">
            <div className="col-md-12">
              <TextField
                autoFocus
                margin="dense"
                id="name"
                label="Enter Shop Name"
                type="text"
                onChange={(e) => setConform(e.target.value)}
                fullWidth
              />
            </div>
            <div className="col-md-12">
              <TextField
                fullWidth
                name="password"
                placeholder="password"
                onChange={(e) => setPassword(e.target.value)}
                label="Enter Password"
              />
            </div>
          </div>
        }
        dialogActionButton={
          <>
            <Button onClick={toggleCustomModel} color="primary">
              Cancel
            </Button>
            <Button
              disabled={shopUsername != conform}
              onClick={onDeleteShop}
              color="secondary"
            >
              Confirm
            </Button>
          </>
        }
      />

      <Card>
        <Card.Header className={classes.header}>
          <button
            className="back-button mt-1"
            title="Back"
            onClick={() => props.history.push("/shop")}
          ></button>
        </Card.Header>
        <Card.Body>
          <ListGroup variant="flush">
            <Row>
              <Col>
                <ListGroup.Item className={classes.coladjust}>
                  <PersonOutlineOutlinedIcon />
                  <strong className={classes.title}>Owner Name </strong>
                  <div style={{ marginLeft: "30px" }}>
                    {shopDataById?.username}
                  </div>
                </ListGroup.Item>
                <ListGroup.Item className={classes.coladjust}>
                  <CallOutlinedIcon />
                  <strong className={classes.title}>Phone </strong>
                  <div style={{ marginLeft: "80px" }}>
                    {shopDataById?.phone || "-"}
                  </div>
                </ListGroup.Item>
              </Col>
              <Col>
                <ListGroup.Item className={classes.coladjust}>
                  <MailOutlineSharpIcon />
                  <strong className={classes.title}>Email </strong>
                  <div style={{ marginLeft: "180px" }}>
                    {shopDataById?.email}
                  </div>
                </ListGroup.Item>
                <ListGroup.Item className={classes.coladjust}>
                  <StorefrontIcon />
                  <strong className={classes.title}>Number Of Shops </strong>
                  <div style={{ marginLeft: "88px" }}>
                    {shopDataById?.number_of_shops}
                  </div>
                </ListGroup.Item>
              </Col>
            </Row>
          </ListGroup>
        </Card.Body>
      </Card>
      <MaterialTable
        style={{ padding: "20px", marginTop: "15px" }}
        title={
          <div className="page-title d-flex justify-content-between">
            <button
              className="btn btn-primary primary-out"
              type="submit"
              onClick={() =>
                props.history.push(`/shop/add/${shopDataById?.username}`)
              }
            >
              Add Shop for {shopDataById?.username}
            </button>
          </div>
        }
        columns={[
          {
            title: "Shop Id",
            field: "id",
          },
          {
            title: "User Name",
            field: "username",
          },
          {
            title: "Email",
            field: "email",
          },
          {
            title: "Phone",
            field: "phone",
          },
          {
            title: "Status",
            field: "available",
            render: (rowData) => (
              <Switch
                onChange={() =>
                  handleChange(rowData?.username, rowData.available)
                }
                checked={rowData.available}
              />
            ),
          },
          {
            title: "Created Date",
            field: "created_date",
            render: (rowData) =>
              rowData.created_date && (
                <>{moment(rowData.created_date).format("DD-MM-YYYY")}</>
              ),
          },
          {
            title: "Action",
            field: "action",
            render: (rowData: any) => (
              <>
                <div className="d-flex">
                  <Tooltip title="Edit">
                    <IconButton
                      aria-label="edit"
                      onClick={() => editShop(rowData?.username)}
                    >
                      <EditIcon color="primary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Soft Delete">
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteShop(rowData?.username)}
                    >
                      <DeleteIcon color="secondary" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Hard Delete">
                    <IconButton
                      aria-label="delete"
                      onClick={() => harddeleteShop(rowData?.username)}
                    >
                      <DeleteIcon color="error" />
                    </IconButton>
                  </Tooltip>
                </div>
              </>
            ),
          },
        ]}
        data={
          shopListArray && shopListArray.length > 0
            ? shopListArray.map((shopListObj: any, index) => {
                return {
                  name: shopListObj?.billing?.name,
                  number_of_shops: shopListObj?.number_of_shops,
                  username: shopListObj.username,
                  email: shopListObj.email,
                  phone: shopListObj.phone || "-",
                  created_date: shopListObj.created_date,
                  updated_date: shopListObj.updated_date,
                  available:
                    shopListObj.is_active == true &&
                    shopListObj.is_delete == false,
                  id: shopListObj.id,
                };
              })
            : []
        }
        options={{
          paging: true,
          pageSize: 10,
          pageSizeOptions: [50, 100, 200],
          sorting: true,
          actionsColumnIndex: -1,
        }}
      />
    </>
  );
}

export default ShopListSub;
